// Categories shown in the "Table of Content" sidebar on the FAQ page.
export const faqCategories = ["General", "Trust and safety", "Services", "Payment", "Office and Cleaning"];

export const faqItems = [
  {
    category: "General",
    q: "How do I upload my EPK?",
    a: "Head to your Artist Dashboard and select \"Create EPK\". Our AI EPK generator will walk you through adding your biography, music, photos, and social links, then publish a shareable page you can send to press and curators."
  },
  {
    category: "General",
    q: "How do I create an artist profile?",
    a: "Click \"Create Account\" in the top navigation, choose the artist option, and fill in your basic details. You can start distributing music and building your EPK as soon as your profile is set up."
  },
  {
    category: "Services",
    q: "What genres does MusicUntamed support?",
    a: "All genres — with deep experience in Afrobeats, Amapiano, R&B, Hip-Hop, and Gospel. Our distribution, promotion, and playlist pitching services work with any style of music."
  },
  {
    category: "Payment",
    q: "How do I get paid from streams?",
    a: "Royalties are collected from every platform you distribute to and paid out monthly directly to your linked account. You can track earnings any time from your Artist Dashboard."
  },
  {
    category: "Trust and safety",
    q: "Is my personal information kept private?",
    a: "Yes. We only use your information to deliver the services you sign up for, and we never sell your data. You can review or update what we hold from your account settings at any time."
  },
  {
    category: "Payment",
    q: "Can I update or cancel my plan later?",
    a: "Yes — you can upgrade, downgrade, or cancel any service or plan from your Artist Dashboard at any time, with no long-term lock-in."
  }
];
